import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {
    Aangifte, BokkzAlgDataService, BokkzIbDataService,
    IncomeTaxEntity, PGAAftrekbareGiften
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import { Subscription, takeUntil } from 'rxjs';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {Router} from "@angular/router";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiLoadingModule } from '@snelstart/ui-loading';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { GewoneGiftenComponent } from './gewone-giften/gewone-giften.component';
import { PeriodiekeGiftenComponent } from './periodieke-giften/periodieke-giften.component';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-pga-aftrekbare-giften',
  templateUrl: './pga-aftrekbare-giften.component.html',
  styleUrls: ['./pga-aftrekbare-giften.component.scss'],
  imports: [
    SharedUiDetailsModule,
    SharedUiAlertModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiLoadingModule,
    SharedUiDialogModule,
    GewoneGiftenComponent,
    PeriodiekeGiftenComponent,
    CommonModule
  ]
})
export class PgaAftrekbareGiftenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private drempelGiftenSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    drempelGiften: any;

    public anbiOptionsNaam: SelectFormControlItem<string>[] = [];
    public anbiOptionsPlaats: SelectFormControlItem<string>[] = [];
    public resultCount = 0; // Nieuwe variabele voor het bijhouden van het aantal resultaten

    public isDefAangifte = {} as boolean;

    public zoekAnbiFg = {} as FormGroup

    searchResults = "";
    @Input() searchPerformed: boolean = false;

    @Output() updateSearchResults = new EventEmitter<{
        results: any[];
        performed: boolean;
        count: number;
    }>();

    public dialogVisible = false;
    public resultaat: any;

    public showDialog() {
        this.dialogVisible = true;
    }

    public formGroup = this.fb.group({
        test: [''],
    });

    headers: string[] = []; // Definieer headers als een array van strings
    rows: string[][] = [];  // Definieer rows als een array van arrays van strings
    filteredRows: string[][] = []; // Gefilterde rijen
    searchTerm = ''; // Gebruikersinvoer voor zoeken

    public showSearchSpinner = false
    public showResult = false;

    public gewoneGiftenFg = {} as FormGroup

    public optionsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"},
    ]

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.zoekAnbiFg = this.fb.group({
            zoekWaardeNaam: [''],
            zoekWaardePlaats: ['']
        });
    }

    searchAnbi() {

        const query = {
            "search": [
                {
                    "zoekWaarde": this.zoekAnbiFg.get('zoekWaardeNaam')?.value,
                    "zoekOpdrachtType": "INSTELLINGSNAAM"
                },
                {
                    "zoekWaarde": this.zoekAnbiFg.get('zoekWaardePlaats')?.value,
                    "zoekOpdrachtType": "VESTIGINGSPLAATS"
                }
            ]
        };

        this.dataService.searchAnbi(query).subscribe(
            (response: any[]) => {
                this.searchPerformed = true
                this.resultCount = response.length;

                response = response.map(anbi => ({
                    ...anbi,
                    naam: this.capitalizeWords(anbi.naam),
                    vestigingsPlaats: this.capitalizeWords(anbi.vestigingsPlaats),
                }));

                this.searchResults = response.map(anbi =>
                    `- ${anbi.naam} | ${anbi.vestigingsPlaats} | ${anbi.ingangsDatum || ''} | ${anbi.eindDatum || ''} | ${anbi.fiscaalNummer || ''} | ${anbi.ingangsDatumCultuur || ''} | ${anbi.eindDatumCultuur || ''}`
                ).join('\n');

                // Splits de geformatteerde string in rijen en kolommen
                this.rows = this.searchResults.split('\n').map(row => row.split(' | '));
                this.filteredRows = this.rows;

                // Definieer de headers
                this.headers = ['Naam', 'Plaats', 'Ingang', 'Einde', 'Fiscaalnummer', 'Ingang Cultuur', 'Einde Cultuur'];
                this.updateSearchResults.emit({
                    results: response,
                    performed: true,
                    count: response.length,
                });

                this.anbiOptionsNaam = response.map(anbi => ({
                    value: anbi.naam + ', ' + anbi.vestigingsPlaats,
                    label: anbi.naam + ', ' + anbi.vestigingsPlaats,
                    ingangsDatum: anbi.ingangsDatum != undefined ? anbi.ingangsDatum : '',
                    ingangsdatumCultuur: anbi.ingangsDatumCultuur != undefined ? anbi.ingangsDatumCultuur : '',
                    einddatumCultuur: anbi.eindDatumCultuur != undefined ? anbi.eindDatumCultuur : '',
                    intrekkingsDatumCultuur: anbi.intrekkingsDatumCultuur != undefined ? anbi.intrekkingsDatumCultuur : '',
                    fiscaalNummer: anbi.fiscaalNummer != undefined ? anbi.fiscaalNummer : '',
                }));
                this.anbiOptionsPlaats = response.map(anbi => ({
                    value: anbi.naam + ', ' + anbi.vestigingsPlaats,
                    label: anbi.naam + ', ' + anbi.vestigingsPlaats,
                    ingangsDatum: anbi.ingangsDatum != undefined ? anbi.ingangsDatum : '',
                    ingangsdatumCultuur: anbi.ingangsDatumCultuur != undefined ? anbi.ingangsDatumCultuur : '',
                    einddatumCultuur: anbi.eindDatumCultuur != undefined ? anbi.eindDatumCultuur : '',
                    intrekkingsDatumCultuur: anbi.intrekkingsDatumCultuur != undefined ? anbi.intrekkingsDatumCultuur : '',
                    fiscaalNummer: anbi.fiscaalNummer != undefined ? anbi.fiscaalNummer : '',
                }));
            },
            (error) => {console.error('Error:', error)}
        );
    }

    filterTable() {
        console.log('searchTerm:', this.searchTerm); // Voeg dit toe om de waarde van searchTerm te controleren
        if (!this.searchTerm) {
            this.filteredRows = this.rows;
            return;
        }

        const searchTermLower = this.searchTerm.toLowerCase();
        this.filteredRows = this.rows.filter(row =>
            row.some(cell => cell.toLowerCase().includes(searchTermLower))
        );
    }


    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        })
        this.drempelGiftenSubscription =this.dataService.drempelGiften.subscribe((value) => {
            this.drempelGiften = value;
        });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe(); // Unsubscribe from income tax entity
        }

    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.gewoneGiftenFg.dirty;
    }
    tonenSpinner() {
        this.showSearchSpinner = true
        this.showResult = true
        setTimeout(() => {
            this.showSearchSpinner = false;
        }, 1000);
    }

    capitalizeWords(text: string): string {
        if (!text) return '';

        const exception = 'culturele anbi'; // De combinatie die lowercase moet blijven
        const exceptionLower = exception.toLowerCase();

        return text
            .split(new RegExp(`(${exception})`, 'i')) // Splits tekst rond de uitzondering (case-insensitive)
            .map(part => {
                // Behoud de uitzondering in lowercase
                if (part.toLowerCase() === exceptionLower) {
                    return exceptionLower;
                }

                // Pas hoofdlettertransformatie toe op andere delen
                return part
                    .split(' ')
                    .map(word => {
                        // Speciale behandeling voor woorden die beginnen met 's-
                        if (word.toLowerCase().startsWith("'s-")) {
                            // Vind de eerste letter na 's-
                            const prefix = "'s-";
                            return (
                                prefix +
                                word.charAt(prefix.length).toUpperCase() +
                                word.slice(prefix.length + 1).toLowerCase()
                            );
                        }
                        // Standaard hoofdlettertransformatie
                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    })
                    .join(' ');
            })
            .join('');
    }

}
